import React from 'react';
import { Field, useField, useForm } from 'react-final-form';

import { CardType } from '../../../../types/cardType';
import { detailsForceSavedMethods } from '../../../../utils/cashier';
import Checkbox from '../../../Checkbox/Checkbox';
import type { Props } from '../../SavePaymentInfo';
import { fastDepositField, saveCardField } from '../../SavePaymentInfo';

import { TXTWCL_Save_this_as_my_preferred_paym_ELL } from './FirstTimeDepositCheckboxes.messages.json';

const FirstTimeDepositCheckboxes: React.FC<Props> = ({ type }) => {
  const form = useForm();
  const forceSavePaymentMethod = detailsForceSavedMethods(type);

  useField(saveCardField, { initialValue: forceSavePaymentMethod });

  return (
    <>
      {CardType.Skrill1Tap !== type && CardType.Pix !== type && (
        <Field name={saveCardField} type="checkbox">
          {({ input: { onChange, checked } }) => (
            <Checkbox
              name={saveCardField}
              checked={checked}
              onChange={(event) => {
                onChange(event);
                checked && form.change(fastDepositField, undefined);
              }}
              label={TXTWCL_Save_this_as_my_preferred_paym_ELL}
              disabled={forceSavePaymentMethod}
            />
          )}
        </Field>
      )}
      <Field name={fastDepositField} type="checkbox" component={() => null} />
    </>
  );
};

export default FirstTimeDepositCheckboxes;
